import React, { useState } from 'react';

const Paineis = props => {

    const [tooltipVisible, setTooltipVisible] = useState(false);

    const handleButtonClick = () => {
        setTooltipVisible(!tooltipVisible);
    };

    let tooltip = ''
    if(props.tooltip) {
        tooltip = (
            <i className="fa-question-circle"></i>
        )
    }

    return (
        <div className={props.size} >
            <div className="info-box">
                <span className={props.className}><i className={props.icon}></i></span>

                <div className="info-box-content">
                    <span className="info-box-text"
                        style={{ cursor: 'pointer', position: 'relative', zIndex: 1 }}
                        onClick={handleButtonClick}
                    ><i className='fa fa-question-circle text-aqua'></i> {props.title}</span>
                    <span className="info-box-number">{props.value}</span>
                </div>
            </div>

                
            {tooltipVisible && (
                <div
                    style={{
                        position: 'absolute',
                        top: '30px',  // Ajuste conforme necessário para a altura desejada
                        left: '50%',
                        transform: 'translateX(-50%)',
                        backgroundColor: '#333',
                        color: '#fff',
                        padding: '5px',
                        borderRadius: '3px',
                        whiteSpace: 'normal',
                        maxWidth: '1000px',  // Defina o tamanho máximo desejado
                        overflowWrap: 'break-word',  // Força a quebra de palavra
                        zIndex: 9999,  // Garante que fique acima de outros elementos
                        textAlign: 'center',  // Alinha o texto ao centro
                        marginLeft: '-100px',  // Metade do maxWidth
                    }}
                    onClick={handleButtonClick}
                >
                    {props.tooltip}
                </div>
            )}
        </div>
    )
};

export default Paineis;
